<app-doc-properties-list [item]="item" (closeDialog)="hideDialog();"></app-doc-properties-list>